import LogInMessage from "@iewcasia/Components/LogInMessage";
import { styles as commonOrderTableStyles } from "@iewcasia/Components/OrderAcknowledgement";
import OrderDocumentDownload from "@iewcasia/Components/OrderDocumentDownload";
import OrderTablesTitle from "@iewcasia/Components/OrderTablesTitle";
import { getOrderInvoices, getPackingList } from "@iewcasia/Services/OrderService";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import DataTable from "@insite/mobius/DataTable";
import {
    DataTableBody,
    DataTableCell,
    DataTableHead,
    DataTableHeader,
    DataTableRow,
    Link,
    Typography,
} from "@insite/mobius/index";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OrderLines {
    warehouse: string;
}

interface OwnProps {
    erpOrderNumber: string;
    orderDate: string;
    orderLines: OrderLines[];
    guid: string;
    status: string;
    customerNumber: string;
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        language: state.context.session.language,
        IsAuthenticated: state.context.session.isAuthenticated,
        hideDownloadDocumentButtons: (state.context.settings.settingsCollection as any).myAccountSettings?.hideDownloadDocumentButtons,
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const OrderPackingLists = ({ erpOrderNumber, customerNumber, status, language, IsAuthenticated, hideDownloadDocumentButtons }: Props) => {
    const [items, setItems] = useState([]);

    const fetchInvoices = async () => {
        const res = (await getOrderInvoices({
            orderNumber: erpOrderNumber,
            customerNumber,
        })) as any;
        setItems(res?.invoices || []);
    };

    const getInvoiceType = (type: any) => {
        switch (type) {
            case "M":
                return "Invoice";
            case "N":
                return "Invoice Cancellation";
            case "O":
                return "Credit Memo";
        }
    };

    useEffect(() => {
        if (status === "Completed") {
            fetchInvoices();
        }
    }, []);

    const message = translate("Log In to see Invoices");

    return (
        <>
            <OrderTablesTitle text="Invoices" />
            {items.length ? (
                <StyledWrapper {...commonOrderTableStyles.dataTableWrapper}>
                    <DataTable>
                        <DataTableHead>
                            <DataTableHeader>{translate("Date")}</DataTableHeader>
                            <DataTableHeader>{translate("Document #")}</DataTableHeader>
                            <DataTableHeader>{translate("Type")}</DataTableHeader>
                            <DataTableHeader>{translate("Status")}</DataTableHeader>
                            <DataTableHeader>{translate("Items")}</DataTableHeader>
                            <DataTableHeader>{translate("Total")}</DataTableHeader>
                            {!hideDownloadDocumentButtons && (
                                <DataTableHeader>{translate("Download")}</DataTableHeader>
                            )}
                        </DataTableHead>
                        <DataTableBody>
                            {items.map((row: any) => (
                                <DataTableRow key={row.id}>
                                    <DataTableCell>
                                        <Link href={`/my-account/invoices/details?invoiceNumber=${row.invoiceNumber}`}>
                                            {getLocalizedDateTime({
                                                dateTime: new Date(row.invoiceDate),
                                                language,
                                            })}
                                        </Link>
                                    </DataTableCell>
                                    <DataTableCell>
                                        <Link href={`/my-account/invoices/details?invoiceNumber=${row.invoiceNumber}`}>
                                            {row.invoiceNumber}
                                        </Link>
                                    </DataTableCell>
                                    <DataTableCell>{getInvoiceType(row.invoiceType)}</DataTableCell>
                                    <DataTableCell>{row.status}</DataTableCell>
                                    <DataTableCell>{row.invoiceLines?.length || 0}</DataTableCell>
                                    <DataTableCell>{row.invoiceTotalDisplay}</DataTableCell>
                                    {!hideDownloadDocumentButtons && (
                                        <DataTableCell>
                                            <OrderDocumentDownload
                                                type="Invoice"
                                                name={`invoice_${row.invoiceNumber}`}
                                                id={row.id}
                                            />
                                        </DataTableCell>
                                    )}
                                </DataTableRow>
                            ))}
                        </DataTableBody>
                    </DataTable>
                </StyledWrapper>
            ) : (
                <>
                    {IsAuthenticated && (
                        <Typography as="p" variant="p" {...commonOrderTableStyles.noResults}>
                            {translate("No Documents Available")}
                        </Typography>
                    )}
                    {!IsAuthenticated && (
                        <Typography as="p" variant="p" {...commonOrderTableStyles.noResults}>
                            <LogInMessage title={message} />
                        </Typography>
                    )}
                </>
            )}
        </>
    );
};

export default connect(mapStateToProps)(OrderPackingLists as any) as any;
